import { render, staticRenderFns } from "./avatar.vue?vue&type=template&id=eef96b3e&scoped=true&"
import script from "./avatar.vue?vue&type=script&lang=js&"
export * from "./avatar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eef96b3e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/imc/portal/dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('eef96b3e')) {
      api.createRecord('eef96b3e', component.options)
    } else {
      api.reload('eef96b3e', component.options)
    }
    module.hot.accept("./avatar.vue?vue&type=template&id=eef96b3e&scoped=true&", function () {
      api.rerender('eef96b3e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "assets/js/components/user/profile/tabs/avatar.vue"
export default component.exports